<template>
  <el-drawer
    :withHeader="false"
    :visible.sync="drawer"
    :before-close="handleClose"
    direction="ttb"
    size="100%"
  >
    <el-descriptions class="margin-top" :column="6" border>
      <el-descriptions-item>
        <template slot="label"> 选择文件</template>
        <el-upload
          ref="aupload"
          :auto-upload="false"
          class="upload-demo"
          action="/"
          accept=".doc,.docx,.xls,.xlsx"
          :on-change="handleChange"
          :on-remove="handRemove"
          :disabled="isAdmin"
        >
          <el-button slot="trigger" size="small" type="primary"
            >导入Excel/world</el-button
          >
          <el-button
            style="margin-left: 10px"
            size="small"
            type="success"
            @click="submitUpload"
            :disabled="isAdmin"
            >上传到服务器</el-button
          >

          <div slot="tip" class="el-upload__tip">
            只能上传导入Excel/world文件
          </div>
        </el-upload>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 所属分类 </template>
        <el-cascader
          :show-all-levels="false"
          v-model="eab_formtemp.fmtp08"
          :options="functionTempleteList"
          :disabled="isAdmin"
          :props="{
            value: 'fctm01',
            label: 'fctm02',
            children: 'children',
          }"
        ></el-cascader>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <span @click="batchSetShow = true" style="cursor: pointer"
            >选择协同流程</span
          >
        </template>
        <el-select
          v-model="flowId"
          placeholder="请选择"
          value-key="fafl03"
          @change="currentSel"
          :disabled="disabled"
        >
          <el-option
            v-for="item in flowLayoutList"
            :key="item.fafl01"
            :label="item.fafl03"
            :value="item.fafl01"
          >
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 模版名称 </template>
        <el-input
          :disabled="isAdmin"
          style="width: 200px"
          v-model="eab_formtemp.fmtp03"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 重要程度 </template>
        <el-select
          :disabled="isAdmin"
          v-model="eab_formtemp.fmtp09"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 操作 </template>
        <el-button size="small" @click="AddOrUpdateFormTemp">保存</el-button>
      </el-descriptions-item>
    </el-descriptions>

    <el-row style="height: 90%">
      <el-col :span="12" style="height: 100%; overflow: auto">
        <el-descriptions
          v-for="(item, index) in tempFields"
          :key="index"
          class="margin-top"
          :column="3"
          border
        >
          <el-descriptions-item>
            <template slot="label"> 表单变量 </template>

            <el-tooltip
              class="item"
              effect="dark"
              :content="item.fmfd06"
              :disabled="item.fmfd06.length > 9 ? false : true"
              placement="top"
            >
              <el-button style="width: 100px" type="text">{{
                item.fmfd06.length > 9
                  ? item.fmfd06.slice(0, 9) + "..."
                  : item.fmfd06
              }}</el-button>
            </el-tooltip>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 类型指定 </template>
            <el-select
              :disabled="isAdmin"
              v-model="item.fmfd04"
              placeholder="请选择"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label"> 指定可编辑权限 </template>
            <el-cascader
              :options="deptData"
              :props="{
                multiple: true,
                value: 'fadt01',
                label: 'fadt03',
                children: 'children',
              }"
              clearable
              filterable
              v-model="item.fmfd05"
              :show-all-levels="false"
              :placeholder="item.fmfd05Name || '请选择人员'"
              :title="item.fmfd05Name || '请选择人员'"
            ></el-cascader>
          </el-descriptions-item>
        </el-descriptions>
      </el-col>
      <el-col :span="12" style="height: 100%; overflow: auto">
        <iframe
          v-if="eab_formtemp.fmtp05"
          :src="this.$store.state.baseUrl + eab_formtemp.fmtp05"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </el-col>
    </el-row>

    <el-dialog
      title="批量设置"
      :visible.sync="batchSetShow"
      :append-to-body="true"
      width="50%"
    >
      <p
        style="margin: 10px; 
          display: flex;
          justify-content: flex-start;
        "
      >
        表单字段：
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
      </p>
      <el-checkbox-group
        @change="handleCheckedItemsChange"
        v-model="batchCheckList"
        style="
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
        "
      >
        <el-checkbox
          v-for="item in tempFields"
          :label="item.fmfd01"
          :key="item.fmfd01"
          style="margin: 10px; width: 20%;"
          >{{ item.fmfd06 }}</el-checkbox
        >
      </el-checkbox-group>
      <el-row style="margin: 10px">
        <el-col :span="10"
          >选择人员:
          <el-cascader
            :options="deptData"
            :props="{
              multiple: true,
              value: 'fadt01',
              label: 'fadt03',
              children: 'children',
            }"
            clearable
            filterable
            v-model="batchPeople"
            :show-all-levels="false"
          ></el-cascader
        ></el-col>
        <el-col :span="10">
          选择类型:
          <el-select v-model="batchType" :disabled="isAdmin">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="4">
          <el-button type="primary" @click="batchSetSubmit"
            >确定</el-button
          ></el-col
        >
      </el-row>
    </el-dialog>
  </el-drawer>
</template>

<script>
// 超管设置的模板，项管只能修改部分。
import { adminRoute, enterpriseRoute, projectRoute } from "@/router";
import {
  AddOrUpdateFormTemps,
  GetFunctionTemplate,
  GetOneFormTemps,
  GetFormAuditFlowList,
  GetOneFormAuditFlow,
} from "@/setAxios.js";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      drawer: false,
      disabled: true,
      name: "",
      options: [
        {
          value: 1,
          label: "一般",
        },
        {
          value: 2,
          label: "重要",
        },
      ],
      typeOptions: [
        // 1文本 2音频 3视频 4表单编号 5金额 6是否选择项
        // 7填表人员 8提交时间 9附件 10视点 11选择集 12图片
        {
          value: 1,
          label: "文本",
        },
        {
          value: 2,
          label: "音频",
        },
        {
          value: 3,
          label: "视频",
        },
        {
          value: 4,
          label: "表单编号",
        },
        {
          value: 5,
          label: "金额",
        },
        {
          value: 6,
          label: "是否选择项",
        },
        {
          value: 7,
          label: "填表人员",
        },
        {
          value: 8,
          label: "提交时间",
        },
        {
          value: 9,
          label: "附件",
        },
        {
          value: 10,
          label: "视点",
        },
        {
          value: 11,
          label: "选择集",
        },
        {
          value: 12,
          label: "图片",
        },
      ],
      deptData: [], //流程
      typeValue: "",
      typeOptions2: [
        {
          value: 1,
          label: "发起人",
        },
        {
          value: 2,
          label: "审核人",
        },
      ],
      powerValue: "",
      // 表单内容
      fd: new FormData(),
      eab_formtemp: {
        fmtp01: 0,
        fmtp02: localStorage.xid,
        fmtp03: "",
        fmtp04: "",
        fmtp05: "",
        fmtp06: "",
        fmtp07: localStorage.id,
        fmtp08: null,
        fmtp09: 1,
      },
      functionTempleteList: [],
      tempFields: [],
      Id: null, //父传的id
      flowLayoutList: [],
      flowId: null, //流程id
      batchSetShow: false,
      batchCheckList: [],
      batchPeople: [],
      batchType: null,
      checkAll: false,
      isIndeterminate: false,
      isAdmin: false,
      Admin: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleCheckAllChange(val) {
      this.batchCheckList = val ? this.tempFields.map((x) => x.fmfd01) : [];
      this.isIndeterminate = false;
    },
    handleCheckedItemsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.tempFields.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.tempFields.length;
    },
    //批量设置
    batchSetSubmit() {
      if (this.batchCheckList) {
        this.tempFields
          .filter((x) => this.batchCheckList.includes(x.fmfd01))
          .forEach((item) => {
            this.batchType ? (item.fmfd04 = this.batchType) : "";
            this.batchPeople ? (item.fmfd05 = this.batchPeople) : "";
          });
      }
      this.tempFields = JSON.parse(JSON.stringify(this.tempFields));
      this.batchSetShow = false;
      this.batchCheckList = [];
      this.batchPeople = [];
      this.batchType = null;
    },

    //判断当前路由权限
    open() {
      // Object.assign(this.$data, this.$options.data())
      // 超管端--编辑
      if (this.Id != null && this.Admin != null) {
        this.GetOneFormTemps();
      } else {
        this.FormAdd();
      }
      if (this.Admin == 1) {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }
      // 如果再项管中新增模板，则放开指定协同流程and指定可编辑权限
      if (projectRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
        this.disabled = false;

        this.GetFormAuditFlowList();
      } else if (adminRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
        this.disabled = true;
        this.isAdmin = false;//超管端可编辑
      }
      this.getData();
    },
    getData() {
      let params = {
        companyId: localStorage.pid,
        xid: localStorage.xid,
      };
      // 获取全部/公司功能模块
      GetFunctionTemplate({ params }).then((res) => {
        if (res.Code > 0) {
          if (adminRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
            res.Data.allfunctiontemplates.forEach((v) => {
              if (v.fctm03 == 0) {
                this.functionTempleteList.push(v);
              }
              res.Data.allfunctiontemplates.filter((item) => {
                if (v.fctm01 == item.fctm03) {
                  if (v.children) {
                    v.children.push(item);
                  } else {
                    v.children = [];
                    v.children.push(item);
                  }
                }
              });
            });
          } else {
            this.functionTempleteList = this.getTreeDate(
              res.Data.projectfunctiontemplates,
              "fctm01",
              "fctm03"
            ).filter((el) => el.fctm01 == localStorage.keyId);
            console.log(localStorage.keyId);
          }
        }
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          result.push(item);
        }
      });
      return result;
    },
    //编辑----- 单个模板数据
    GetOneFormTemps() {
      let params = {
        id: this.Id,
        xid: localStorage.xid,
      };
      GetOneFormTemps({ params }).then((res) => {
        if (res.Code > 0) {
          this.tempFields = res.Data.tempFields;
          this.eab_formtemp = res.Data.formTemp;

          if (res.Data.formTemp.flow != null) {
            this.flowId = res.Data.formTemp.flow.fafl01;
            this.GetOneFormAuditFlow(this.flowId);
          } else {
            this.flowId = null;
          }
          this.name = this.eab_formtemp.fmtp08;
          this.drawer = true;
        }
      });
    },
    currentSel(selVal) {
      this.flowId = selVal;
      this.GetOneFormAuditFlow(selVal);
    },
    // 获取单个流程中的详细人员内容
    GetOneFormAuditFlow(id) {
      let _this = this;
      let params = {
        id,
      };
      GetOneFormAuditFlow({ params }).then((res) => {
        let arr = res.Data.detailList.filter((v) => v.fadt07 == 1);
        let arr1 = [{ fadt01: -1, fadt03: "发起人" }];
        _this.deptData = arr.map((v) => {
          v.children = [];
          v.fadt04.split(",").forEach((i, index) => {
            v.children.push({
              fadt03: v.name.split(",")[index],
              fadt01: i,
            });
          });
          return v;
        });
        _this.deptData = _this.deptData.concat(arr1).reverse();
      });
    },
    // 新增-----
    FormAdd() {
      let _this = this;
      this.eab_formtemp = {
        fmtp01: 0,
        fmtp02: localStorage.xid,
        fmtp03: "",
        fmtp04: "",
        fmtp05: "",
        fmtp06: "",
        fmtp07: localStorage.id,
        fmtp08: null,
        fmtp09: 1,
      };
      this.flowId = null;
      this.tempFields = [];
      this.drawer = true;
      // 清空缓存
      setTimeout(() => {
        _this.$refs.aupload.clearFiles();
      }, 400);
    },
    // 获取表单审核流程列表
    GetFormAuditFlowList() {
      let params = {
        xid: localStorage.xid,
        tempId: localStorage.keyId,
        searchword: "",
        pageIndex: 1,
        pageSize: 9999,
        xid: localStorage.xid,
      };
      GetFormAuditFlowList({ params }).then((res) => {
        this.flowLayoutList = res.Data.list;
      });
    },
    handleChange(file) {
      this.fd.append("file", file.raw);
    },
    handRemove() {
      this.fd.delete("file");
    },
    async submitUpload() {
      if (this.eab_formtemp.fmtp08 == null) {
        this.$message.warning("所属分类不能为空！");
        return;
      } else {
        this.eab_formtemp.fmtp08 = Number(this.eab_formtemp.fmtp08.slice(-1));
      }
      if (localStorage.isAdmin == false && this.flowId == null) {
        console.log("bushji超管放");
        this.$message.warning("协同流程不能为空！");
      }

      if (this.eab_formtemp.fmtp03.trim() == "") {
        this.$message.warning("模板名称不能为空！");
        return;
      }
      this.eab_formtemp.fmtp06 = new Date();
      this.fd.append("formtemp", JSON.stringify(this.eab_formtemp));
      this.fd.append("tempfield", JSON.stringify(null));
      if (projectRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
        this.fd.append("qid", localStorage.pid);
        this.fd.append("xid", localStorage.xid);
        this.fd.append("flowId", this.flowId);
      }
      let res = await AddOrUpdateFormTemps(this.fd);
      if (res.Code) {
        this.$message.success("添加成功");
        this.eab_formtemp = res.Data.formTemp;
        this.tempFields = res.Data.tempFields;
      }
    },
    AddOrUpdateFormTemp() {
      if (this.eab_formtemp.fmtp08 == null) {
        this.$message.warning("所属分类不能为空！");
        return;
      } else if (this.eab_formtemp.fmtp08.length) {
        this.eab_formtemp.fmtp08 = Number(this.eab_formtemp.fmtp08.slice(-1));
      }
      if (this.eab_formtemp.fmtp03.trim() == "") {
        this.$message.warning("模板名称不能为空！");
        return;
      }
      if (localStorage.isAdmin == false && this.flowId == null) {
        console.log("bushji超管放");
        this.$message.warning("协同流程不能为空！");
      }

      this.tempFields = this.tempFields.map((e) => {
        if (Array.isArray(e.fmfd05)) {
          e.fmfd05 = Array.from(new Set(e.fmfd05.map((v) => v.pop()))).join();
          return e;
        } else {
          return e;
        }
      });
      let fd = new FormData();
      fd.append("formtemp", JSON.stringify(this.eab_formtemp));
      fd.append("tempfield", JSON.stringify(this.tempFields));
      if (projectRoute.indexOf(this.$route.name.toLowerCase()) > 0) {
        fd.append("qid", localStorage.pid);
        fd.append("xid", localStorage.xid);
        fd.append("flowId", this.flowId);
      }
      const loading = this.$loading({
        lock: true,
        text: "处理中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      AddOrUpdateFormTemps(fd).then((res) => {
        loading.close();
        if (res.Code > 0) {
          this.$message.success("保存成功");
          this.GetOneFormTemps();
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    handleClose(done) {
      let _this = this;
      this.$confirm("确认关闭？").then((_) => {
        _this.$emit("signStatusVerdict", true);
        done();
      });
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped></style>
